var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4522_8811)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    rx: 43,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4522_8811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 0L86 86L-3.75918e-06 86L0 -3.75918e-06L86 0Z",
    fill: "#F26A1C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter0_f_4522_8811)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 39,
    r: 57,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_4522_8811)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -22.7335,
    cy: -39.7333,
    r: 128.267,
    transform: "rotate(90 -22.7335 -39.7333)",
    fill: "#FF006B"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 358.217,
    y: -0.216667,
    width: 233.433,
    height: 358.433,
    transform: "rotate(90 358.217 -0.216667)",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.433333
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4522_8811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F26A1C"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4522_8811)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.998,
    cy: 15.5,
    r: 30,
    fill: "#FFE600"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter3_f_4522_8811)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.12305,
    cy: 94.875,
    r: 50.625,
    fill: "#FF006B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43 27C45.2998 27 47.2976 28.2938 48.3047 30.1934C50.36 29.5623 52.6873 30.0603 54.3135 31.6865C55.9397 33.3127 56.4377 35.64 55.8066 37.6953C57.7062 38.7024 59 40.7002 59 43C59 45.2998 57.7062 47.2976 55.8066 48.3047C56.4377 50.36 55.9397 52.6873 54.3135 54.3135C52.6873 55.9397 50.36 56.4377 48.3047 55.8066C47.2976 57.7062 45.2998 59 43 59C40.7002 59 38.7024 57.7062 37.6953 55.8066C35.64 56.4377 33.3127 55.9397 31.6865 54.3135C30.0603 52.6873 29.5623 50.36 30.1934 48.3047C28.2938 47.2976 27 45.2998 27 43C27 40.7002 28.2938 38.7024 30.1934 37.6953C29.5623 35.64 30.0603 33.3127 31.6865 31.6865C33.3127 30.0603 35.64 29.5623 37.6953 30.1934C38.7024 28.2938 40.7002 27 43 27ZM49.3877 37.582C48.6507 37.0465 47.6189 37.2104 47.083 37.9473L41.5518 45.5508L38.751 42.75C38.1066 42.1058 37.0613 42.1057 36.417 42.75C35.7727 43.3943 35.7728 44.4396 36.417 45.084L40.584 49.25C40.9252 49.5912 41.3988 49.7662 41.8799 49.7285C42.3608 49.6907 42.8012 49.4438 43.085 49.0537L49.752 39.8867C50.2874 39.1498 50.1245 38.1179 49.3877 37.582Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4522_8811",
    x: 60.4,
    y: -79.6,
    width: 237.2,
    height: 237.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.8,
    result: "effect1_foregroundBlur_4522_8811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4522_8811",
    x: -255,
    y: -272,
    width: 464.533,
    height: 464.533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 52,
    result: "effect1_foregroundBlur_4522_8811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4522_8811",
    x: -12.002,
    y: -64.5,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_4522_8811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4522_8811",
    x: -119.502,
    y: -30.75,
    width: 251.25,
    height: 251.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.5,
    result: "effect1_foregroundBlur_4522_8811"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4522_8811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    rx: 43,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4522_8811"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358,
    width: 233,
    height: 358,
    transform: "rotate(90 358 0)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4522_8811"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationIcon);
export default __webpack_public_path__ + "static/media/verification-icon.4d3da431f233c69bc4e6e095361c2acd.svg";
export { ForwardRef as ReactComponent };